// extracted by mini-css-extract-plugin
export default {"scroll":"horizontal-scroll_scroll__J2eRC"};